export interface Config {
    backendUrl: string | undefined;
    enableReference: boolean;
    googleAnalyticsTag: string | undefined;
    sentryDsn: string | undefined;
    sentryEnvironment: string | undefined;
    mapboxToken: string | undefined;
    mapboxPrTilesetId: string | undefined;
    mapboxPrLayer: string | undefined;
    mapboxPrReunionTilesetId: string | undefined;
    mapboxPrReunionLayer: string | undefined;
}

export const loadConfigFromRootDataset = (root: HTMLElement | null = document.getElementById('root')): Config => {
    if (root === null) {
        throw new Error(`"root" element not found in the DOM.`);
    }

    return {
        backendUrl: root.dataset.backendUrl,
        enableReference: root.dataset.enableReference === 'true',
        googleAnalyticsTag: root.dataset.googleAnalyticsTag,
        sentryDsn: root.dataset.sentryDsn,
        sentryEnvironment: root.dataset.sentryEnvironment,
        mapboxToken: root.dataset.mapboxToken,
        mapboxPrTilesetId: root.dataset.mapboxPrTilesetId,
        mapboxPrLayer: root.dataset.mapboxPrLayer,
        mapboxPrReunionTilesetId: root.dataset.mapboxPrReunionTilesetId,
        mapboxPrReunionLayer: root.dataset.mapboxPrReunionLayer,
    };
};
